import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=13f15740&scoped=true&"
import script from "./DropZone.vue?vue&type=script&lang=js&"
export * from "./DropZone.vue?vue&type=script&lang=js&"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=13f15740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f15740",
  null
  
)

/* custom blocks */
import block0 from "./DropZone.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "DropZone.vue"
export default component.exports